import { useTranslation } from 'react-i18next';

interface TypingIndicatorProps {
  label?: string;
  className?: string;
}

export function TypingIndicator({ label, className = '' }: TypingIndicatorProps) {
  const { t } = useTranslation('interview');
  const resolvedLabel = label ?? t('typing');
  return (
    <div
      className={`flex items-center gap-2 text-sm text-neutral-500 ${className}`}
      role="status"
      aria-label={resolvedLabel}
    >
      <div className="flex gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="inline-block h-1.5 w-1.5 animate-bounce rounded-full bg-neutral-400"
            style={{ animationDelay: `${i * 200}ms` }}
          />
        ))}
      </div>
      <span>{resolvedLabel}</span>
    </div>
  );
}
